export class Presenter<T> {
    OnInit(): void {}
    OnEnterMainScene(): void {}
    OnExitMainScene(): void {}
}